// extracted by mini-css-extract-plugin
export default {"option":"option__NEhEb","option-title":"option-title__YjDeJ","option-body":"option-body__HWh4C","option-description":"option-description__vX-Cz"};